import { SiteChartsConfig } from '../../components/SiteCharts';

export const erabChartConfig: SiteChartsConfig = {
  title: 'ERAB Establishment',
  apiEndpoint: '/api/lte/erab-establishment',
  csvFilename: 'erab_establishment',
  chartImageFilename: 'erab_establishment_chart',
  series: [
    {
      name: 'ERAB Establishment Success',
      type: 'bar',
      yAxisIndex: 0,
      color: 'success',  // Semantic color name
      dataKey: 'erab_success'
    },
    {
      name: 'ERAB Establishment Attempt',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Semantic color name
      dataKey: 'erab_attempt'
    },
    {
      name: 'ERAB Establishment SR',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Semantic color name
      dataKey: 'erab_establishment_sr',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Data Accessibility %',
      position: 'left',
      min: 0,
      max: 100,
      nameGap: 50,
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'ERAB Success',
      dataKey: 'erab_success'
    },
    {
      header: 'ERAB Attempt',
      dataKey: 'erab_attempt'
    },
    {
      header: 'ERAB SR (%)',
      dataKey: 'erab_establishment_sr',
      isPercentage: true
    }
  ]
};

export const volteChartConfig: SiteChartsConfig = {
  title: 'VoLTE Establishment',
  apiEndpoint: '/api/lte/volte-establishment',
  csvFilename: 'volte_establishment',
  chartImageFilename: 'volte_establishment_chart',
  series: [
    {
      name: 'VoLTE Establishment Success',
      type: 'bar',
      yAxisIndex: 0,
      color: 'success',  // Semantic color name
      dataKey: 'volte_success'
    },
    {
      name: 'VoLTE Establishment Attempt',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Semantic color name
      dataKey: 'volte_attempt'
    },
    {
      name: 'VoLTE Establishment SR',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Semantic color name
      dataKey: 'volte_establishment_sr',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Data Accessibility %',
      position: 'left',
      min: 0,
      max: 100,
      nameGap: 50,
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'VoLTE Success',
      dataKey: 'volte_success'
    },
    {
      header: 'VoLTE Attempt',
      dataKey: 'volte_attempt'
    },
    {
      header: 'VoLTE SR (%)',
      dataKey: 'volte_establishment_sr',
      isPercentage: true
    }
  ]
};

export const rrcConnectionChartConfig: SiteChartsConfig = {
  title: 'RRC Connection Establishment',
  apiEndpoint: '/api/lte/rrc-connection-establishment',
  csvFilename: 'rrc_connection_establishment',
  chartImageFilename: 'rrc_connection_establishment_chart',
  series: [
    {
      name: 'RRC Connection Establishment Success',
      type: 'bar',
      yAxisIndex: 0,
      color: 'success',  // Green (#009B3A)
      dataKey: 'rrc_success'
    },
    {
      name: 'RRC Connection Establishment Attempt',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Yellow (#EAB308)
      dataKey: 'rrc_attempt'
    },
    {
      name: 'RRC Connection Establishment SR',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Brown (#422006)
      dataKey: 'rrc_establishment_sr',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Success Rate %',
      position: 'left',
      min: 0,
      max: 100,
      nameGap: 50,
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'RRC Success',
      dataKey: 'rrc_success'
    },
    {
      header: 'RRC Attempt',
      dataKey: 'rrc_attempt'
    },
    {
      header: 'RRC SR (%)',
      dataKey: 'rrc_establishment_sr',
      isPercentage: true
    }
  ]
};

export const erabDropRateChartConfig: SiteChartsConfig = {
  title: 'ERAB Drop Rate',
  apiEndpoint: '/api/lte/erab-drop-rate',
  csvFilename: 'erab_drop_rate',
  chartImageFilename: 'erab_drop_rate_chart',
  series: [
    {
      name: 'ERAB Drop Counts',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Dark teal color for counts (matching attempt pattern)
      dataKey: 'erab_drop_counts'
    },
    {
      name: 'ERAB Drop Rate',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Blue color for rate (matching other rate charts)
      dataKey: 'erab_drop_rate',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Drop Rate %',
      position: 'left',
      nameGap: 50,
      // Dynamic scaling - no min/max specified
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'ERAB Drop Counts',
      dataKey: 'erab_drop_counts'
    },
    {
      header: 'ERAB Drop Rate (%)',
      dataKey: 'erab_drop_rate',
      isPercentage: true
    }
  ]
};

export const volteDropRateChartConfig: SiteChartsConfig = {
  title: 'VoLTE Drop Rate',
  apiEndpoint: '/api/lte/volte-drop-rate',
  csvFilename: 'volte_drop_rate',
  chartImageFilename: 'volte_drop_rate_chart',
  series: [
    {
      name: 'VoLTE Drop Counts',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Dark teal color for counts (matching attempt pattern)
      dataKey: 'volte_drop_counts'
    },
    {
      name: 'VoLTE Drop Rate',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Blue color for rate (matching other rate charts)
      dataKey: 'volte_drop_rate',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Drop Rate %',
      position: 'left',
      nameGap: 50,
      // Dynamic scaling - no min/max specified
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'VoLTE Drop Counts',
      dataKey: 'volte_drop_counts'
    },
    {
      header: 'VoLTE Drop Rate (%)',
      dataKey: 'volte_drop_rate',
      isPercentage: true
    }
  ]
};

export const handinOverS1ChartConfig: SiteChartsConfig = {
  title: 'Handin Over S1 Interface',
  apiEndpoint: '/api/lte/handin-over-s1',
  csvFilename: 'handin_over_s1',
  chartImageFilename: 'handin_over_s1_chart',
  series: [
    {
      name: 'HandIn Success',
      type: 'bar',
      yAxisIndex: 0,
      color: 'success',  // Green color for success
      dataKey: 'handin_success'
    },
    {
      name: 'HandIn Attempts',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color for attempts
      dataKey: 'handin_attempts'
    },
    {
      name: 'HandIn Success Rate',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Blue color for rate
      dataKey: 'handin_success_rate',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Success Rate %',
      position: 'left',
      min: 0,
      max: 100,
      nameGap: 50,
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'HandIn Success',
      dataKey: 'handin_success'
    },
    {
      header: 'HandIn Attempts',
      dataKey: 'handin_attempts'
    },
    {
      header: 'HandIn Success Rate (%)',
      dataKey: 'handin_success_rate',
      isPercentage: true
    }
  ]
};

export const handoutOverS1ChartConfig: SiteChartsConfig = {
  title: 'Handout Over S1 Interface',
  apiEndpoint: '/api/lte/handout-over-s1',
  csvFilename: 'handout_over_s1',
  chartImageFilename: 'handout_over_s1_chart',
  series: [
    {
      name: 'HandOut Success',
      type: 'bar',
      yAxisIndex: 0,
      color: 'success',  // Green color for success
      dataKey: 'handout_success'
    },
    {
      name: 'HandOut Attempts',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color for attempts
      dataKey: 'handout_attempts'
    },
    {
      name: 'HandOut Success Rate',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Blue color for rate
      dataKey: 'handout_success_rate',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Success Rate %',
      position: 'left',
      min: 0,
      max: 100,
      nameGap: 50,
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'HandOut Success',
      dataKey: 'handout_success'
    },
    {
      header: 'HandOut Attempts',
      dataKey: 'handout_attempts'
    },
    {
      header: 'HandOut Success Rate (%)',
      dataKey: 'handout_success_rate',
      isPercentage: true
    }
  ]
};

export const intraFreqX1HoChartConfig: SiteChartsConfig = {
  title: 'Intra-frequency X1-HO',
  apiEndpoint: '/api/lte/intra-freq-x1-ho',
  csvFilename: 'intra_freq_x1_ho',
  chartImageFilename: 'intra_freq_x1_ho_chart',
  series: [
    {
      name: 'Handover Success',
      type: 'bar',
      yAxisIndex: 0,
      color: 'success',  // Green color for success
      dataKey: 'handover_success'
    },
    {
      name: 'Handover Attempts',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color for attempts
      dataKey: 'handover_attempts'
    },
    {
      name: 'Handover Success Rate',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Blue color for rate
      dataKey: 'handover_success_rate',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Success Rate %',
      position: 'left',
      min: 0,
      max: 100,
      nameGap: 50,
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'Handover Success',
      dataKey: 'handover_success'
    },
    {
      header: 'Handover Attempts',
      dataKey: 'handover_attempts'
    },
    {
      header: 'Handover Success Rate (%)',
      dataKey: 'handover_success_rate',
      isPercentage: true
    }
  ]
};

export const interFreqX1HoChartConfig: SiteChartsConfig = {
  title: 'Inter-frequency X1-HO',
  apiEndpoint: '/api/lte/inter-freq-x1-ho',
  csvFilename: 'inter_freq_x1_ho',
  chartImageFilename: 'inter_freq_x1_ho_chart',
  series: [
    {
      name: 'Handover Success',
      type: 'bar',
      yAxisIndex: 0,
      color: 'success',  // Green color for success
      dataKey: 'handover_success'
    },
    {
      name: 'Handover Attempts',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color for attempts
      dataKey: 'handover_attempts'
    },
    {
      name: 'Handover Success Rate',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Blue color for rate
      dataKey: 'handover_success_rate',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Success Rate %',
      position: 'left',
      min: 0,
      max: 100,
      nameGap: 50,
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'Handover Success',
      dataKey: 'handover_success'
    },
    {
      header: 'Handover Attempts',
      dataKey: 'handover_attempts'
    },
    {
      header: 'Handover Success Rate (%)',
      dataKey: 'handover_success_rate',
      isPercentage: true
    }
  ]
};

export const sgNbAdditionChartConfig: SiteChartsConfig = {
  title: 'SgNB Addition',
  apiEndpoint: '/api/lte/sgnb-addition',
  csvFilename: 'sgnb_addition',
  chartImageFilename: 'sgnb_addition_chart',
  series: [
    {
      name: 'SgNB Addition ACK Success',
      type: 'bar',
      yAxisIndex: 0,
      color: 'success',  // Green color for success
      dataKey: 'sgnb_addition_ack_success'
    },
    {
      name: 'SgNB Addition Attempts',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color for attempts
      dataKey: 'sgnb_addition_attempts'
    },
    {
      name: 'SgNB Addition SR',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Blue color for rate
      dataKey: 'sgnb_addition_sr',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Success Rate %',
      position: 'left',
      min: 0,
      max: 100,
      nameGap: 50,
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'SgNB Addition ACK Success',
      dataKey: 'sgnb_addition_ack_success'
    },
    {
      header: 'SgNB Addition Attempts',
      dataKey: 'sgnb_addition_attempts'
    },
    {
      header: 'SgNB Addition SR (%)',
      dataKey: 'sgnb_addition_sr',
      isPercentage: true
    }
  ]
};

/**
 * DL S1-U GTP Data Volume (LTE Site Level)
 * 
 * Shows downlink S1-U GTP data volume in GB for LTE sites.
 * Uses data from LTE_GLOBAL_KPI table.
 * 
 * Chart displays:
 * - Dark teal bars: DL S1-U Data Volume (GB)
 */
export const dlGtpDataVolumeChartConfig: SiteChartsConfig = {
  title: 'DL GTP Data Volume',
  apiEndpoint: '/api/lte/dl-gtp-data-volume',
  csvFilename: 'dl_gtp_data_volume',
  chartImageFilename: 'dl_gtp_data_volume_chart',
  series: [
    {
      name: 'DL Data Volume',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Dark teal color (matching NR Data Volume)
      dataKey: 'dl_gtp_data_volume'
    }
  ],
  yAxes: [
    {
      name: 'Volume (GB)',
      position: 'left',
      nameGap: 70,
      formatter: '{value}'
    },
    {
      name: '',
      position: 'right',
      formatter: ''
    }
  ],
  tableColumns: [
    {
      header: 'DL Data Volume (GB)',
      dataKey: 'dl_gtp_data_volume'
    }
  ]
};

/**
 * UL S1-U GTP Data Volume (LTE Site Level)
 * 
 * Shows uplink S1-U GTP data volume in GB for LTE sites.
 * Uses data from LTE_GLOBAL_KPI table.
 * 
 * Chart displays:
 * - Dark teal bars: UL S1-U Data Volume (GB)
 */
export const ulGtpDataVolumeChartConfig: SiteChartsConfig = {
  title: 'UL GTP Data Volume',
  apiEndpoint: '/api/lte/ul-gtp-data-volume',
  csvFilename: 'ul_gtp_data_volume',
  chartImageFilename: 'ul_gtp_data_volume_chart',
  series: [
    {
      name: 'UL Data Volume',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Dark teal color (matching NR Data Volume)
      dataKey: 'ul_gtp_data_volume'
    }
  ],
  yAxes: [
    {
      name: 'Volume (GB)',
      position: 'left',
      nameGap: 70,
      formatter: '{value}'
    },
    {
      name: '',
      position: 'right',
      formatter: ''
    }
  ],
  tableColumns: [
    {
      header: 'UL Data Volume (GB)',
      dataKey: 'ul_gtp_data_volume'
    }
  ]
};

export const maximumEndcChartConfig: SiteChartsConfig = {
  title: 'Maximum ENDC',
  apiEndpoint: '/api/lte/maximum-endc',
  csvFilename: 'maximum_endc',
  chartImageFilename: 'maximum_endc_chart',
  series: [
    {
      name: 'Maximum ENDC Connected UE Sessions',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Dark teal color (matching NR Maximum ENDC and Data Volume)
      dataKey: 'maximum_endc_connected_ue_sessions'
    }
  ],
  yAxes: [
    {
      name: 'Sessions',
      position: 'left',
      nameGap: 70,
      formatter: '{value}'
    },
    {
      name: '',
      position: 'right',
      formatter: ''
    }
  ],
  tableColumns: [
    {
      header: 'Maximum ENDC Connected UE Sessions',
      dataKey: 'maximum_endc_connected_ue_sessions'
    }
  ]
};

/**
 * NR (5G) Chart Configurations
 * ================================
 * Chart configurations for NR/5G KPI metrics
 */

/**
 * SgNB Addition Success Rate (NR Site Level)
 * 
 * Shows SgNB (Secondary gNodeB) addition attempts, ACK success count, and success rate
 * for NR sites. Uses data from NR_FR2_GLOBAL_KPI table.
 * 
 * Chart displays:
 * - Orange bars: Total SgNB Addition Request Attempts
 * - Green bars: Total SgNB Addition Request ACK Success
 * - Blue line: Success rate percentage (0-100%)
 */
export const sgNbAdditionNrChartConfig: SiteChartsConfig = {
  title: 'SgNB Addition',
  apiEndpoint: '/api/nr/sgnb-addition',
  csvFilename: 'sgnb_addition_nr',
  chartImageFilename: 'sgnb_addition_nr_chart',
  series: [
    {
      name: 'SgNB Addition Attempts',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color for attempts
      dataKey: 'sgnb_addition_attempts'
    },
    {
      name: 'SgNB Addition ACK Success',
      type: 'bar',
      yAxisIndex: 0,
      color: 'success',  // Green color for success
      dataKey: 'sgnb_addition_ack_success'
    },
    {
      name: 'SgNB Addition SR',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Blue color for rate
      dataKey: 'sgnb_addition_sr',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Success Rate %',
      position: 'left',
      min: 0,
      max: 100,
      nameGap: 50,
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'SgNB Addition Attempts',
      dataKey: 'sgnb_addition_attempts'
    },
    {
      header: 'SgNB Addition ACK Success',
      dataKey: 'sgnb_addition_ack_success'
    },
    {
      header: 'SgNB Addition SR (%)',
      dataKey: 'sgnb_addition_sr',
      isPercentage: true
    }
  ]
};

/**
 * Maximum ENDC Connected UE Sessions (NR Site Level)
 * 
 * Shows the maximum number of EN-DC (E-UTRAN New Radio - Dual Connectivity) 
 * connected UE sessions for NR sites. Uses data from NR_FR2_GLOBAL_KPI table.
 * 
 * Chart displays:
 * - Orange bars: Maximum number of ENDC sessions
 */
export const maximumEndcNrChartConfig: SiteChartsConfig = {
  title: 'Maximum ENDC',
  apiEndpoint: '/api/nr/maximum-endc',
  csvFilename: 'maximum_endc_nr',
  chartImageFilename: 'maximum_endc_nr_chart',
  series: [
    {
      name: 'Maximum ENDC Sessions',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color (matching SgNB Addition)
      dataKey: 'maximum_endc_sessions'
    }
  ],
  yAxes: [
    {
      name: 'Sessions',
      position: 'left',
      nameGap: 70,
      formatter: '{value}'
    },
    {
      name: '',
      position: 'right',
      formatter: ''
    }
  ],
  tableColumns: [
    {
      header: 'Maximum ENDC Sessions',
      dataKey: 'maximum_endc_sessions'
    }
  ]
};

/**
 * ENDC UE Session Drop Rate (NR Site Level)
 * 
 * Shows ENDC UE session drop count and drop rate percentage for NR sites.
 * Uses data from NR_FR2_GLOBAL_KPI table.
 * 
 * Chart displays:
 * - Orange bar: ENDC UE Session Drop Count
 * - Blue line: Drop rate percentage (dynamically scaled)
 */
export const endcUeSessionDropNrChartConfig: SiteChartsConfig = {
  title: 'ENDC UE Session Drop Rate',
  apiEndpoint: '/api/nr/endc-ue-session-drop',
  csvFilename: 'endc_ue_session_drop_nr',
  chartImageFilename: 'endc_ue_session_drop_nr_chart',
  series: [
    {
      name: 'ENDC UE Session Drop Count',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color (matching SgNB Addition)
      dataKey: 'endc_ue_session_drop_count'
    },
    {
      name: 'ENDC UE Session Drop Rate',
      type: 'line',
      yAxisIndex: 1,
      color: 'total',  // Blue color for rate (matching SgNB Addition)
      dataKey: 'endc_ue_session_drop_rate',
      isPercentage: true
    }
  ],
  yAxes: [
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    },
    {
      name: 'Drop Rate %',
      position: 'left',
      nameGap: 50,
      // Dynamic scaling - no min/max specified
      formatter: '{value}%'
    }
  ],
  tableColumns: [
    {
      header: 'ENDC UE Session Drop Count',
      dataKey: 'endc_ue_session_drop_count'
    },
    {
      header: 'ENDC UE Session Drop Rate (%)',
      dataKey: 'endc_ue_session_drop_rate',
      isPercentage: true
    }
  ]
};

/**
 * DL S1-U GTP Data Volume (NR Site Level)
 * 
 * Shows downlink S1-U GTP data volume in GB for NR sites.
 * Uses data from NR_FR2_GLOBAL_KPI table.
 * 
 * Chart displays:
 * - Orange bars: DL S1-U Data Volume (GB)
 */
export const dlGtpDataVolumeNrChartConfig: SiteChartsConfig = {
  title: 'DL GTP Data Volume',
  apiEndpoint: '/api/nr/dl-gtp-data-volume',
  csvFilename: 'dl_gtp_data_volume_nr',
  chartImageFilename: 'dl_gtp_data_volume_nr_chart',
  series: [
    {
      name: 'DL Data Volume',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color (matching NR color scheme)
      dataKey: 'dl_s1u_data_volume'
    }
  ],
  yAxes: [
    {
      name: 'Volume (GB)',
      position: 'left',
      nameGap: 70,
      formatter: '{value}'
    },
    {
      name: '',
      position: 'right',
      formatter: ''
    }
  ],
  tableColumns: [
    {
      header: 'DL Data Volume (GB)',
      dataKey: 'dl_s1u_data_volume'
    }
  ]
};

/**
 * UL S1-U GTP Data Volume (NR Site Level)
 * 
 * Shows uplink S1-U GTP data volume in GB for NR sites.
 * Uses data from NR_FR2_GLOBAL_KPI table.
 * 
 * Chart displays:
 * - Green bars: UL S1-U Data Volume (GB)
 */
export const ulGtpDataVolumeNrChartConfig: SiteChartsConfig = {
  title: 'UL GTP Data Volume',
  apiEndpoint: '/api/nr/ul-gtp-data-volume',
  csvFilename: 'ul_gtp_data_volume_nr',
  chartImageFilename: 'ul_gtp_data_volume_nr_chart',
  series: [
    {
      name: 'UL Data Volume',
      type: 'bar',
      yAxisIndex: 0,
      color: 'warning',  // Orange color (matching Maximum ENDC)
      dataKey: 'ul_s1u_data_volume'
    }
  ],
  yAxes: [
    {
      name: 'Volume (GB)',
      position: 'left',
      nameGap: 70,
      formatter: '{value}'
    },
    {
      name: '',
      position: 'right',
      formatter: ''
    }
  ],
  tableColumns: [
    {
      header: 'UL Data Volume (GB)',
      dataKey: 'ul_s1u_data_volume'
    }
  ]
};

/**
 * Intra CU Handover Success (NR Site Level)
 * 
 * Shows Intra CU Handover attempts, successes, and success rate for NR sites.
 * Uses data from NR_FR2_GLOBAL_KPI table.
 * 
 * Chart displays:
 * - Orange bars: Intra CU Handover Attempts
 * - Green bars: Intra CU Handover Successes
 * - Blue line: Success Rate (%)
 * 
 * Success rate calculation: (Successes / Attempts) × 100
 * When attempts = 0, success rate = 100% (no failures)
 */
export const intraCuHandoverNrChartConfig: SiteChartsConfig = {
  title: 'Intra CU Handover Success',
  apiEndpoint: '/api/nr/intra-cu-handover',
  csvFilename: 'intra_cu_handover_nr',
  chartImageFilename: 'intra_cu_handover_nr_chart',
  series: [
    {
      name: 'Intra CU Handover Attempts',
      type: 'bar',
      yAxisIndex: 1,
      color: 'warning',  // Orange color (matching NR color scheme for attempts)
      dataKey: 'intra_cu_handover_attempts'
    },
    {
      name: 'Intra CU Handover Successes',
      type: 'bar',
      yAxisIndex: 1,
      color: 'success',  // Green color (matching NR color scheme for successes)
      dataKey: 'intra_cu_handover_successes'
    },
    {
      name: 'Success Rate',
      type: 'line',
      yAxisIndex: 0,
      color: 'total',  // Blue color (matching NR color scheme for rates)
      dataKey: 'intra_cu_handover_sr'
    }
  ],
  yAxes: [
    {
      name: 'Success Rate (%)',
      position: 'left',
      nameGap: 70,
      // Dynamic scaling - no min/max specified
      formatter: '{value}%'
    },
    {
      name: 'Count',
      position: 'right',
      nameGap: 50,
      formatter: '{value}'
    }
  ],
  tableColumns: [
    {
      header: 'Intra CU Handover Attempts',
      dataKey: 'intra_cu_handover_attempts'
    },
    {
      header: 'Intra CU Handover Successes',
      dataKey: 'intra_cu_handover_successes'
    },
    {
      header: 'Success Rate (%)',
      dataKey: 'intra_cu_handover_sr',
      isPercentage: true
    }
  ]
};

// ============================================================
// SA (NR Standalone) Chart Configurations
// ============================================================

// --- Accessibility (6 charts) ---

export const saRrcEstablishmentChartConfig: SiteChartsConfig = {
  title: 'RRC Establishment',
  apiEndpoint: '/api/sa/rrc-establishment-success-rate',
  csvFilename: 'sa_rrc_establishment',
  chartImageFilename: 'sa_rrc_establishment_chart',
  series: [
    { name: 'RRC Attempts',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'rrc_establishment_attempts' },
    { name: 'RRC Successes', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'rrc_establishment_successes' },
    { name: 'RRC SR %',      type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'rrc_establishment_successes_rate_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',          position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Success Rate %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'RRC Attempts',  dataKey: 'rrc_establishment_attempts' },
    { header: 'RRC Successes', dataKey: 'rrc_establishment_successes' },
    { header: 'RRC SR (%)',    dataKey: 'rrc_establishment_successes_rate_percent', isPercentage: true }
  ]
};

export const saSignalingConnectionChartConfig: SiteChartsConfig = {
  title: 'Signaling Connection',
  apiEndpoint: '/api/sa/signaling-connection-success-rate',
  csvFilename: 'sa_signaling_connection',
  chartImageFilename: 'sa_signaling_connection_chart',
  series: [
    { name: 'Signaling Conn Attempts',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'sig_conn_estab_attempts' },
    { name: 'Signaling Conn Successes', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'sig_conn_estab_successes' },
    { name: 'Signaling Conn SR %',      type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'sig_conn_estab_success_rate_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',          position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Success Rate %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'Signaling Conn Attempts',  dataKey: 'sig_conn_estab_attempts' },
    { header: 'Signaling Conn Successes', dataKey: 'sig_conn_estab_successes' },
    { header: 'Signaling Conn SR (%)',    dataKey: 'sig_conn_estab_success_rate_percent', isPercentage: true }
  ]
};

export const saDataAccessibilityChartConfig: SiteChartsConfig = {
  title: 'Data Accessibility',
  apiEndpoint: '/api/sa/data-accessibility-percent',
  csvFilename: 'sa_data_accessibility',
  chartImageFilename: 'sa_data_accessibility_chart',
  series: [
    { name: 'DRB Setup Attempts',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'drb_setup_attempts' },
    { name: 'DRB Setup Successes', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'drb_setup_successes' },
    { name: 'Data Accessibility %', type: 'line', yAxisIndex: 1, color: 'total',  dataKey: 'data_accessibility_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',                position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Data Accessibility %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'DRB Setup Attempts',    dataKey: 'drb_setup_attempts' },
    { header: 'DRB Setup Successes',   dataKey: 'drb_setup_successes' },
    { header: 'Data Accessibility (%)', dataKey: 'data_accessibility_percent', isPercentage: true }
  ]
};

export const saDataAccessibilityPer5QiChartConfig: SiteChartsConfig = {
  title: 'Data Accessibility per 5QI',
  apiEndpoint: '/api/sa/data-accessibility-per-5qi-percent',
  csvFilename: 'sa_data_accessibility_per_5qi',
  chartImageFilename: 'sa_data_accessibility_per_5qi_chart',
  series: [
    { name: 'DRB Setup Attempts per 5QI',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'drb_setup_attempts_per5qi' },
    { name: 'DRB Setup Successes per 5QI', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'drb_setup_successes_per5qi' },
    { name: 'Data Accessibility per 5QI %', type: 'line', yAxisIndex: 1, color: 'total',  dataKey: 'data_accessibility_per_5qi_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',                       position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Data Accessibility per 5QI %', position: 'left', min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'DRB Setup Attempts per 5QI',  dataKey: 'drb_setup_attempts_per5qi' },
    { header: 'DRB Setup Successes per 5QI', dataKey: 'drb_setup_successes_per5qi' },
    { header: 'Data Accessibility per 5QI (%)', dataKey: 'data_accessibility_per_5qi_percent', isPercentage: true }
  ]
};

export const saQosFlowAccessibilityChartConfig: SiteChartsConfig = {
  title: 'QoS Flow Accessibility',
  apiEndpoint: '/api/sa/qos-flow-accessibility-percent',
  csvFilename: 'sa_qos_flow_accessibility',
  chartImageFilename: 'sa_qos_flow_accessibility_chart',
  series: [
    { name: 'QoS Flow Accessibility %', type: 'line', yAxisIndex: 0, color: 'info', dataKey: 'qos_flow_accessibility_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Accessibility %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' },
    { name: '',                position: 'right', formatter: '' }
  ],
  tableColumns: [
    { header: 'QoS Flow Accessibility (%)', dataKey: 'qos_flow_accessibility_percent', isPercentage: true }
  ]
};

export const saVonrAccessibilityChartConfig: SiteChartsConfig = {
  title: 'VoNR Accessibility',
  apiEndpoint: '/api/sa/vonr-accessibility-percent',
  csvFilename: 'sa_vonr_accessibility',
  chartImageFilename: 'sa_vonr_accessibility_chart',
  series: [
    { name: 'DRB Setup Attempts (5QI)',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'drb_setup_attempts_5qi' },
    { name: 'DRB Setup Successes (5QI)', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'drb_setup_successes_5qi' },
    { name: 'VoNR Accessibility %',      type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'vonr_accessibility_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',               position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'VoNR Accessibility %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'DRB Setup Attempts (5QI)',  dataKey: 'drb_setup_attempts_5qi' },
    { header: 'DRB Setup Successes (5QI)', dataKey: 'drb_setup_successes_5qi' },
    { header: 'VoNR Accessibility (%)',    dataKey: 'vonr_accessibility_percent', isPercentage: true }
  ]
};

// --- Retainability (4 charts) ---

export const saDataRetainabilityChartConfig: SiteChartsConfig = {
  title: 'Data Retainability',
  apiEndpoint: '/api/sa/data-retainability-percent',
  csvFilename: 'sa_data_retainability',
  chartImageFilename: 'sa_data_retainability_chart',
  series: [
    { name: 'DRB Drops',           type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'drb_drops' },
    { name: 'DRB Setup Successes', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'ng_sa_drb_setup_success' },
    { name: 'Data Retainability %', type: 'line', yAxisIndex: 1, color: 'total',  dataKey: 'data_retainability_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',                 position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Data Retainability %',  position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'DRB Drops',            dataKey: 'drb_drops' },
    { header: 'DRB Setup Successes',  dataKey: 'ng_sa_drb_setup_success' },
    { header: 'Data Retainability (%)', dataKey: 'data_retainability_percent', isPercentage: true }
  ]
};

export const saDataRetainabilityPer5QiChartConfig: SiteChartsConfig = {
  title: 'Data Retainability per 5QI',
  apiEndpoint: '/api/sa/data-retainability-per-5qi-percent',
  csvFilename: 'sa_data_retainability_per_5qi',
  chartImageFilename: 'sa_data_retainability_per_5qi_chart',
  series: [
    { name: '5QI Drops',                   type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'fiveqi_drops' },
    { name: 'DRB Setup Successes per 5QI', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'ng_sa_drb_setup_success_per_5qi' },
    { name: 'Data Retainability per 5QI %', type: 'line', yAxisIndex: 1, color: 'total',  dataKey: 'data_retainability_per_5qi_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',                        position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Data Retainability per 5QI %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: '5QI Drops',                    dataKey: 'fiveqi_drops' },
    { header: 'DRB Setup Successes per 5QI',  dataKey: 'ng_sa_drb_setup_success_per_5qi' },
    { header: 'Data Retainability per 5QI (%)', dataKey: 'data_retainability_per_5qi_percent', isPercentage: true }
  ]
};

export const saVonrRetainabilityChartConfig: SiteChartsConfig = {
  title: 'VoNR Retainability',
  apiEndpoint: '/api/sa/vonr-retainability-percent',
  csvFilename: 'sa_vonr_retainability',
  chartImageFilename: 'sa_vonr_retainability_chart',
  series: [
    { name: 'VoNR Drops',                  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'vonr_drops' },
    { name: 'DRB Setup Successes per 5QI', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'ng_sa_drb_setup_success_per_5qi' },
    { name: 'VoNR Retainability %',        type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'vonr_retainability_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',               position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'VoNR Retainability %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'VoNR Drops',                  dataKey: 'vonr_drops' },
    { header: 'DRB Setup Successes per 5QI', dataKey: 'ng_sa_drb_setup_success_per_5qi' },
    { header: 'VoNR Retainability (%)',       dataKey: 'vonr_retainability_percent', isPercentage: true }
  ]
};

export const saUeCallDropRateChartConfig: SiteChartsConfig = {
  title: 'UE Call Drop Rate',
  apiEndpoint: '/api/sa/ue-call-drop-rate-percent',
  csvFilename: 'sa_ue_call_drop_rate',
  chartImageFilename: 'sa_ue_call_drop_rate_chart',
  series: [
    { name: 'UE Call Drops',            type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'ue_call_drops' },
    { name: 'UE Call Release Commands', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'ue_call_release_commands' },
    { name: 'UE Call Drop Rate %',      type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'ue_call_drop_rate_percent', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',              position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Call Drop Rate %',   position: 'left',  nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'UE Call Drops',            dataKey: 'ue_call_drops' },
    { header: 'UE Call Release Commands', dataKey: 'ue_call_release_commands' },
    { header: 'UE Call Drop Rate (%)',    dataKey: 'ue_call_drop_rate_percent', isPercentage: true }
  ]
};

// --- Handover (5 charts) ---

export const saInterCuHandoutChartConfig: SiteChartsConfig = {
  title: 'Inter-CU Handout',
  apiEndpoint: '/api/sa/inter-cu-handout-success-rate-percent',
  csvFilename: 'sa_inter_cu_handout',
  chartImageFilename: 'sa_inter_cu_handout_chart',
  series: [
    { name: 'Inter-CU Handout Attempts',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'inter_cu_ho_cn_attempts' },
    { name: 'Inter-CU Handout Successes', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'inter_cu_ho_ue_success' },
    { name: 'Inter-CU Handout SR %',      type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'inter_cu_handout_successrate', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',          position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Success Rate %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'Inter-CU Handout Attempts',  dataKey: 'inter_cu_ho_cn_attempts' },
    { header: 'Inter-CU Handout Successes', dataKey: 'inter_cu_ho_ue_success' },
    { header: 'Inter-CU Handout SR (%)',    dataKey: 'inter_cu_handout_successrate', isPercentage: true }
  ]
};

export const saInterCuHandinChartConfig: SiteChartsConfig = {
  title: 'Inter-CU Handin',
  apiEndpoint: '/api/sa/inter-cu-handin-success-rate-percent',
  csvFilename: 'sa_inter_cu_handin',
  chartImageFilename: 'sa_inter_cu_handin_chart',
  series: [
    { name: 'Inter-CU Handin Attempts',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'inter_cu_hi_attempts' },
    { name: 'Inter-CU Handin Successes', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'inter_cu_hi_success' },
    { name: 'Inter-CU Handin SR %',      type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'inter_cu_handin_successrate', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',          position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Success Rate %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'Inter-CU Handin Attempts',  dataKey: 'inter_cu_hi_attempts' },
    { header: 'Inter-CU Handin Successes', dataKey: 'inter_cu_hi_success' },
    { header: 'Inter-CU Handin SR (%)',    dataKey: 'inter_cu_handin_successrate', isPercentage: true }
  ]
};

export const saInterCuIntraFreqHandoutChartConfig: SiteChartsConfig = {
  title: 'Inter-CU Intra-Freq Handout',
  apiEndpoint: '/api/sa/inter-cu-intra-freq-handout-success-rate-percent',
  csvFilename: 'sa_inter_cu_intra_freq_handout',
  chartImageFilename: 'sa_inter_cu_intra_freq_handout_chart',
  series: [
    { name: 'Inter-CU Intra-Freq Handout Attempts',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'inter_cu_intra_freq_ho_cn_attempts' },
    { name: 'Inter-CU Intra-Freq Handout Successes', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'inter_cu_intra_freq_ho_ue_success' },
    { name: 'Inter-CU Intra-Freq Handout SR %',      type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'inter_cu_intra_freq_handout_successrate', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',          position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Success Rate %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'Intra-Freq Handout Attempts',  dataKey: 'inter_cu_intra_freq_ho_cn_attempts' },
    { header: 'Intra-Freq Handout Successes', dataKey: 'inter_cu_intra_freq_ho_ue_success' },
    { header: 'Intra-Freq Handout SR (%)',    dataKey: 'inter_cu_intra_freq_handout_successrate', isPercentage: true }
  ]
};

export const saInterCuInterFreqHandoutChartConfig: SiteChartsConfig = {
  title: 'Inter-CU Inter-Freq Handout',
  apiEndpoint: '/api/sa/inter-cu-inter-freq-handout-success-rate-percent',
  csvFilename: 'sa_inter_cu_inter_freq_handout',
  chartImageFilename: 'sa_inter_cu_inter_freq_handout_chart',
  series: [
    { name: 'Inter-CU Inter-Freq Handout Attempts',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'inter_cu_inter_freq_ho_cn_attempts' },
    { name: 'Inter-CU Inter-Freq Handout Successes', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'inter_cu_inter_freq_ho_ue_success' },
    { name: 'Inter-CU Inter-Freq Handout SR %',      type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'inter_cu_inter_freq_handout_successrate', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',          position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Success Rate %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'Inter-Freq Handout Attempts',  dataKey: 'inter_cu_inter_freq_ho_cn_attempts' },
    { header: 'Inter-Freq Handout Successes', dataKey: 'inter_cu_inter_freq_ho_ue_success' },
    { header: 'Inter-Freq Handout SR (%)',    dataKey: 'inter_cu_inter_freq_handout_successrate', isPercentage: true }
  ]
};

export const saIntraCuHandoverChartConfig: SiteChartsConfig = {
  title: 'Intra-CU Handover',
  apiEndpoint: '/api/sa/intra-cu-handover-success-rate-percent',
  csvFilename: 'sa_intra_cu_handover',
  chartImageFilename: 'sa_intra_cu_handover_chart',
  series: [
    { name: 'Intra-CU HO Attempts',  type: 'bar',  yAxisIndex: 0, color: 'warning', dataKey: 'intra_cu_ho_attempts' },
    { name: 'Intra-CU HO Successes', type: 'bar',  yAxisIndex: 0, color: 'success', dataKey: 'intra_cu_ho_success' },
    { name: 'Intra-CU HO SR %',      type: 'line', yAxisIndex: 1, color: 'total',   dataKey: 'intra_cu_handover_successrate', isPercentage: true }
  ],
  yAxes: [
    { name: 'Count',          position: 'right', nameGap: 50, formatter: '{value}' },
    { name: 'Success Rate %', position: 'left',  min: 0, max: 100, nameGap: 50, formatter: '{value}%' }
  ],
  tableColumns: [
    { header: 'Intra-CU HO Attempts',  dataKey: 'intra_cu_ho_attempts' },
    { header: 'Intra-CU HO Successes', dataKey: 'intra_cu_ho_success' },
    { header: 'Intra-CU HO SR (%)',    dataKey: 'intra_cu_handover_successrate', isPercentage: true }
  ]
};

// --- Data Volume (1 chart) ---

export const saGtpDataVolumeChartConfig: SiteChartsConfig = {
  title: 'GTP Data Volume',
  apiEndpoint: '/api/sa/gtp-data-volume',
  csvFilename: 'sa_gtp_data_volume',
  chartImageFilename: 'sa_gtp_data_volume_chart',
  series: [
    { name: 'DL GTP Data Volume (MB)', type: 'bar', yAxisIndex: 0, color: 'info',    dataKey: 'dl_gtp_data_volume_mb' },
    { name: 'UL GTP Data Volume (MB)', type: 'bar', yAxisIndex: 0, color: 'warning', dataKey: 'ul_gtp_data_volume_mb' }
  ],
  yAxes: [
    { name: 'Volume (MB)', position: 'left',  nameGap: 60, formatter: '{value}' },
    { name: '',            position: 'right', formatter: '' }
  ],
  tableColumns: [
    { header: 'DL GTP (MB)', dataKey: 'dl_gtp_data_volume_mb' },
    { header: 'UL GTP (MB)', dataKey: 'ul_gtp_data_volume_mb' }
  ]
};




















